import React, {Component} from 'react';
import {Alert, Table} from 'reactstrap';
import {_getListWithdrawal} from '../../../../../services/apis/AdminAffiliate';
import Pages from '../pagination/Pages';
import ItemWithdrawal from "./ItemWithdrawal"
import {changeQuerySearch, parseSearchQuery} from "../../../../../helpers/routes/RouterHelper"

const getInitPage = () =>{
    const parsed = parseSearchQuery();
    return !!parsed.page ? parseInt(parsed.page, 10) : 1;
}

class WithdrawalPage extends Component {
    state = {
        listWithdrawal: [],
        error: '',
        total: 0,
        pages: {
            page: getInitPage(),
            limit: 10,
            maxPage: 1
        }
    }

    componentDidMount() {
        this.getListWithdrawal();
    }

    componentDidUpdate(preProps, preState) {
        const {page} = this.state.pages;
        if (preState.pages.page !== page) {
            this.getListWithdrawal();
        }
    }

    getListWithdrawal = () => {
        const {pages} = this.state;

        _getListWithdrawal(pages)
            .then((result) => {
                if (result.success) {
                    this.setState({
                        listWithdrawal: result.data.docs,
                        error: '',
                        total: result.data.total,
                        pages: {
                            page: result.data.page,
                            limit: 10,
                            maxPage: result.data.pages
                        }

                    });
                } else {
                    this.setState({
                        error: result.message
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    error: error.message
                });
            });
    }
    handleGoToPage = (index) => {
        const {limit, maxPage} = this.state.pages;
        changeQuerySearch({page: index});
        this.setState({
            pages: {
                page: index,
                limit,
                maxPage
            }
        })
    }

    render() {
        const {listWithdrawal, error, pages, total} = this.state;
        return (
            <div className="WithdrawalPage">
                {
                    !!error ? <Alert color="danger">{error}</Alert> : ''
                }
                <h2>Withdrawal({total})</h2>
                <Table>
                    <thead>
                    <tr>
                        <th>USER</th>
                        <th>PAYMENT METHOD</th>
                        <th>PAYPAL EMAIL</th>
                        <th>CREATED</th>
                        <th>STATUS</th>
                        <th>AMOUNT</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        listWithdrawal.map((withdrawal, index) => {
                            return (
                                <ItemWithdrawal
                                    withdrawal={withdrawal}
                                    key={'ItemWitdthdrawal' + index}
                                />
                            );
                        })
                    }
                    </tbody>
                </Table>

                <Pages
                    pages={pages}
                    handleGoToPage={this.handleGoToPage}
                />
            </div>
        );
    }
}

export default WithdrawalPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/withdrawal/WithdrawalPage.js